import { render, staticRenderFns } from "./WYSIWYG.vue?vue&type=template&id=3d5ec24a&"
import script from "./WYSIWYG.vue?vue&type=script&lang=js&"
export * from "./WYSIWYG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports